import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
    root: {
        fontSize: '1.2rem',
        padding: theme.spacing(0, 1.5),
        color: theme.palette.text.primary,
    },
}));

const SelectSingleValue = ({ innerProps, children }) => {
    const classes = useStyles();

    return (
        <Typography className={classes.root} {...innerProps}>
            {children}
        </Typography>
    );
};

SelectSingleValue.defaultProps = {
    innerProps: {},
};

SelectSingleValue.propTypes = {
    children: PropTypes.node.isRequired,
    innerProps: PropTypes.object,
    selectProps: PropTypes.object.isRequired,
};

export default SelectSingleValue;
